import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaUpload } from "react-icons/fa";
import "./UploadImages.css";
import {
  Button,
  CircularProgress,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";

const UploadImages = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [result, setResult] = useState(null);
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const [recommendationType, setRecommendationType] = useState("All");
  const [analizeLoader, setanalizeLoader] = useState(false);
  const [recommendedDropdownData, setrecommendedDropdownData] = useState("");
  const [recommendedProductsLoader, setrecommendedProductsLoader] =
    useState(false);

  // console.log(recommendationType);

  const handleChange = (event) => {
    // console.log(event);
    setrecommendedDropdownData(event.target.value);
  };

  // console.log(age)

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select an image first.");
      return;
    }
    setanalizeLoader(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/recommendation/detect_skin_tone/`,

        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      setResult(response.data);
      setRecommendedProducts([]);
      setanalizeLoader(false);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
  const fetchRecommendations = async () => {
    if (!result?.hex_color) {
      alert("Skin tone not detected yet!");
      return;
    }
    setrecommendedProductsLoader(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_KEY}/recommendation/recommend_by_color/`,

        {
          hex_color: result.hex_color,
          recommendation_type: recommendationType,
        },
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("API Response:", response.data);
      setrecommendedProductsLoader(false);
      if (response.data.recommended_products?.length > 0) {
        setRecommendedProducts(response.data.recommended_products);
      } else {
        setRecommendedProducts([]);
      }
    } catch (error) {
      console.error("Error fetching recommendations:", error);
    }
  };
  useEffect(() => {
    document.body.classList.add("hide-scrollbar");

    return () => {
      document.body.classList.remove("hide-scrollbar"); // cleanup when leaving page
    };
  }, []);

  return (
    <>
      <div className="upload-container">
        <h1 className="title">skin tone detector</h1>
        <p className="subtitle">
          upload an image or take a photo to detect your skin tone.
        </p>

        <div className="button-group">
          <label className="upload-button">
            <FaUpload className="icon" />
            <span style={{ fontFamily: "niavhFont" }}>upload image</span>
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleFileChange}
            />
          </label>

          {/* <button
          className="photo-button"
          onClick={() => document.querySelector('input[type="file"]').click()}
        >
          <FaCamera className="icon" /> Take Photo
        </button> */}
        </div>

        {selectedFile && (
          <div className="preview-container">
            <img src={previewImage} alt="Preview" className="preview-image" />
            <Button
              loading={analizeLoader}
              variant="outlined"
              loadingPosition="end"
              className="analyze-button"
              onClick={handleUpload}
              sx={{ fontFamily: "niavhFont", textTransform: "lowercase" }}
            >
              analyze image
            </Button>
            {/* analizeLoader */}
            {/* <button onClick={handleUpload} className="analyze-button">
            
          </button> */}
          </div>
        )}
        {/* <div
          className="dropdown"
          style={{
            // backgroundColor: "red",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <h2>Detected Skin Tone: </h2>
          <h2>Hex Color:</h2>
          
          <FormControl sx={{ m: 1, minWidth: 220, overflow: "hidden" }}>
            <Select
              value={age}
              onChange={handleChange}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {["Matching", "Balanced", "Contrast"].map((item, index) => (
                <MenuItem
                  // value={10}
                  key={index}
                  onClick={() => {
                    setRecommendationType(item);
                    fetchRecommendations();
                  }}
                >
                  {item}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div> */}

        {result && (
          <div className="result-container">
            <div
              className="dropdown"
              style={{
                // backgroundColor: "red",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                marginTop: "20px",
              }}
            >
              <h2>detected skin tone: {result.skin_tone}</h2>
              <h2>hex color:{result.hex_color}</h2>
              <FormControl sx={{ m: 1, minWidth: 220 }}>
                <Select
                  value={recommendedDropdownData}
                  onChange={handleChange}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    fontFamily: "niavhFont",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "gray", // default border color
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "black", // border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "black", // border when active (focused)
                    },
                  }}
                >
                  <MenuItem value="">
                    <em>recommended products</em>
                  </MenuItem>
                  {["matching", "balanced", "contrast"].map((item, index) => (
                    <MenuItem
                      value={item}
                      sx={{ fontFamily: "niavhFont" }}
                      // value={10}
                      key={index}
                      onClick={() => {
                        setRecommendationType(item);
                        fetchRecommendations();
                      }}
                    >
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {recommendedProductsLoader && (
              <CircularProgress
                color="inherit"
                className="spinnerOfRecomendedProducts"
              />
            )}
            {/* <h2>Detected Skin Tone: {result.skin_tone}</h2>
          <h2>Hex Color:{result.hex_color}</h2>
          <div className="dropdown">
            <button className="recommend-button">
              {recommendationType === "All"
                ? "Recommend Products"
                : recommendationType}
              <span className="arrow-down"></span>
            </button>

            <div className="dropdown-content">
              <div
                onClick={() => {
                  setRecommendationType("All");
                  fetchRecommendations();
                }}
              >
                Recommended Products
              </div>
              <div
                onClick={() => {
                  setRecommendationType("Matching");
                  fetchRecommendations();
                }}
              >
                Matching
              </div>
              <div
                onClick={() => {
                  setRecommendationType("Balanced");
                  fetchRecommendations();
                }}
              >
                Balanced
              </div>
              <div
                onClick={() => {
                  setRecommendationType("Contrast");
                  fetchRecommendations();
                }}
              >
                Contrast
              </div>
            </div> 
          </div>*/}

            {/* <button onClick={fetchRecommendations} className="recommend-button">
            Recommend Products
          </button> */}
            {recommendedProducts.length > 0 && (
              <ul>
                {recommendedProducts.map((item, index) => (
                  <li key={index} className="product-item">
                    <h3>
                      {item.ProductName} -{" "}
                      <a
                        href={item.URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.BrandName}
                      </a>
                    </h3>
                    {item.image_base64 && (
                      <img
                        src={`data:image/png;base64,${item.image_base64}`}
                        alt={item.ProductName}
                        width="150"
                      />
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default UploadImages;
